import AutoplanLogoBlue from '../../../../../icons/AutoplanLogoBlue'

export function LogoLoader() {
  return (
    <div className="slideLogo w-[140px] [&>svg]:w-full [&>svg]:h-auto">
      <AutoplanLogoBlue />
    </div>
  )
}
